import { Route, Routes } from 'react-router-dom'
import { SectionItemsPage } from './sectionItemsPage'

export const ItemListRouter = () => {
    return (
        <Routes>
            <Route
                path="/:section_id/:cat_id?"
                element={<SectionItemsPage />}
            />
        </Routes>
    )
}
